import autocomplete from 'autocomplete.js'


export default {
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/postcode-auto-complete/postcode-auto-complete-actions.ts